import React, { useContext } from 'react';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { SmartCardContext } from '../../../state';
import withErrorBoundary from './error-boundary';
import { ResolveHyperlink } from './resolve-hyperlink';
export var isSharePointDomain = function isSharePointDomain(href) {
  try {
    var hostname = new URL(href).hostname.toLowerCase();
    return hostname.includes('sharepoint.com') || hostname.includes('onedrive.com') || hostname.includes('.live.com');
  } catch (_unused) {
    return false;
  }
};
var HyperlinkResolver = function HyperlinkResolver(_ref) {
  var href = _ref.href;
  var hasSmartCardProvider = !!useContext(SmartCardContext);
  var isHyperlinkResolveExperimentEnabled = FeatureGates.getExperimentValue('platform_editor_resolve_hyperlinks_confluence', 'isEnabled', false) || FeatureGates.getExperimentValue('platform_editor_resolve_hyperlinks_jira', 'isEnabled', false);
  if (!isSharePointDomain(href) || !hasSmartCardProvider || !isHyperlinkResolveExperimentEnabled) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ResolveHyperlink, {
    href: href
  });
};
export default withErrorBoundary(HyperlinkResolver);